

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import { setCache } from '../../General/Actions.js';
import TableComponent from '../../Utils/tableComponent.js';
import Constants from '../../Utils/constants.json';
import downloadIcon from '../../ImageAssets/downloadIcon.png';
import Swal from 'sweetalert2';
import Network from '../../Utils/network.js';
import GeneralUtils from '../../Utils/generalUtils.js';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import NoDataFound from '../../Utils/noDataFound.js';
import PaymentComponent from './Payment';
import SliderModal from '../../Utils/sliderModal.js';
import viewIcon from '../../ImageAssets/viewIcon.png';
import { MdVerticalAlignBottom } from "react-icons/md";
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo.png';

class InvoicesComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            billingName: "",
            contactNumber: "",
            accountId:"",
            currentActiveSubMenu: "OVERVIEW",
            isFloatingSubMenuVisible: false,
            currentTab: "bundles",
            billsHistoryPayload: {
                data:[]
            },
            isPaymentComponent: false,
            secondLastInvoiceDetails: {},
            currentBillDetails:[],
            paymentHistoryPayload: {
                totalRecords: -1,
                data: [],
                withSearch: false
            },
            isPaymentHistoryModalVisible: false,
            tab: "billingHistory",
            isPaymentReceiptVisible: false,
            paymentDetailsObj: {}
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
       
        this.initializeQuerySubscriber(this.props.cache.querySubscriberResponse);
        Network.executeAxios("checkPaymentDetails", "POST", "", (response) => {
            let accountId = this.props.cache.serviceInfo.accountId
            console.log("checkPaymentDetails >> ", response);
            if (response && response.orderId && response.reason && response.status) {
                var reason = response.reason;
                if (reason == "bill_payment") {
                    reason = "bill";
                }
                if (response.status === "SUCCESS") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Payment Successful",
                            html: "<div>Your payment for " + reason + " has been successful</div><div style='text-align:center'>Order Id : " + response.orderId + "</div>",
                            type: '',
                            timer: 3000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                        });
                    }, 1000);
                } else {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Payment Failed",
                            html: "<div>Your payment for " + reason + " has been Failed</div><div style='text-align:center'>Order Id : " + response.orderId + "</div>",
                            type: '',
                            timer: 3000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                        });
                    }, 1000);
                }
            }
            Network.executeAxios("getPaymentDetails", "POST", {}, (paymentResponse) => {
                this.initializePaymentHistory(paymentResponse);
                Network.executeAxios("fetchInvoices", "POST", { "offset": "1", "limit": "10" }, (billsResponse) => {
                    this.initializeBillHistory(billsResponse);
                    this.initializeUserDetails()
                    this.state.accountId = localStorage.getItem("currentAccount");
                    setTimeout(() => {
                        this.setState({ skeltonScreenLoading: false, isLoading: false });
                    }, 100);
                });
            });
        });
    }

    generalBtnClicked(type){
        this.setState({tab: type})
    }

    populateContactSummary() {
        return (
            <div className="col-md-12 m-0 p-0 customerSummaryBox">
                <div className="col-md-12 m-0 summaryBoxHeading">Contact Information</div>
                <div className="col-md-12 m-0 p-3" style={{fontSize: 12}}>
                    <div>480-7000 - Main Office</div>
                    <div>727-2782 - Customer Service</div>
                    <div>462-2782 - Fax</div>
                    <div>811 - Fault Reports</div>
                    <div>www.apua.ag - Online</div>
                </div>
            </div>
        )
    }

    populateAccountSummary(){
        return(
        <div className="col-md-12 m-0 p-0 customerSummaryBox">
            <div className="col-md-12 m-0 summaryBoxHeading">Account Summary</div>
            <div className="col-md-12 m-0 p-0 py-2">
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                    <div className="col-4 summaryBoxLabel">{this.props.locales.BillPaymentPaymentDateTable}</div>
                    <div className="col-8 summaryBoxData" style={{ wordBreak: 'break-word' }}>: &nbsp;{this.state.paymentDetailsObj.paymentDate}</div>
                </div>
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                    <div className="col-4 summaryBoxLabel">{this.props.locales.BillPaymentPaymentReferTable}</div>
                    <div className="col-8 summaryBoxData">: &nbsp;{this.state.paymentDetailsObj.paymentReferance}</div>
                </div>
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                    <div className="col-4 summaryBoxLabel">{this.props.locales.BillPaymentAmtPaidTable} ({Constants.dollarSign})</div>
                    <div className="col-8 summaryBoxData">: &nbsp;{this.state.paymentDetailsObj.amountPaid}</div>
                </div>
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                    <div className="col-4 summaryBoxLabel">{this.props.locales.BillPaymentPaymentModeTable}</div>
                    <div className="col-8 summaryBoxData">: &nbsp;{this.state.paymentDetailsObj.paymentMode}</div>
                </div>
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                    <div className="col-4 summaryBoxLabel">{this.props.locales.BillPaymentOutstandingTable} ({Constants.dollarSign})</div>
                    <div className="col-8 summaryBoxData">: &nbsp;{this.state.paymentDetailsObj.outstandingAfter}</div>
                </div>
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                    <div className="col-4 summaryBoxLabel">{this.props.locales.BillPaymentCommentTable}</div>
                    <div className="col-8 summaryBoxData">: &nbsp;{this.state.paymentDetailsObj.comment}</div>
                </div>
            </div>
        </div>
        )
    }

    initializePaymentHistory = (receivedResponse, searchKeyword) => {
        var paymentResponse = [];
        try {
            paymentResponse = receivedResponse.BillingSystem.response.dataset.recordset
        } catch (err) {

        }
        var finalArrayForPayments = [];
        var finalArrayForSearchPayments = [];
        try {
            for (var i = 0; i < paymentResponse.length; i++) {
                if (searchKeyword && searchKeyword != "") {
                    searchKeyword = searchKeyword.toLowerCase();
                    var currentPaymentMode = paymentResponse[i].payment_mode.toLowerCase();
                    var currentDate = GeneralUtils.formatDateToStandardForm(paymentResponse[i].payment_date, this.props.configurationValues.dateFormatForBilling);
                    var amountPaid = GeneralUtils.formatNumberToStandardForm(paymentResponse[i].amount_paid);
                    if ((currentPaymentMode.indexOf(searchKeyword) > -1) || (paymentResponse[i].transaction_id.indexOf(searchKeyword) > -1) || (currentDate.indexOf(searchKeyword) > -1) || (amountPaid.indexOf(searchKeyword) > -1)) {
                        var tempObject = {
                            "paymentDate": GeneralUtils.formatDateToStandardForm(paymentResponse[i].payment_date, this.props.configurationValues.dateFormatForBilling),
                            "paymentId": paymentResponse[i].payment_id,
                            "paymentReferance": paymentResponse[i].transaction_id,
                            "billAmount": GeneralUtils.formatNumberToStandardForm(paymentResponse[i].amount),
                            "amountPaid": GeneralUtils.formatNumberToStandardForm(paymentResponse[i].amount_paid),
                            "paymentMode": paymentResponse[i].payment_mode,
                            "outstandingAfter": GeneralUtils.formatNumberToStandardForm(paymentResponse[i].outstanding_after),
                            "creditBalanceAfter": GeneralUtils.formatNumberToStandardForm(paymentResponse[i].credit_balance_after),
                            "comment": paymentResponse[i].comment,
                        };
                        finalArrayForSearchPayments.push(tempObject);
                    }
                } else {
                    var tempObject = {
                        "paymentDate": GeneralUtils.formatDateToStandardForm(paymentResponse[i].payment_date, this.props.configurationValues.dateFormatForBilling),
                        "paymentId": paymentResponse[i].payment_id,
                        //"paymentId" : "NA",
                        "paymentReferance": paymentResponse[i].transaction_id,
                        "billAmount": GeneralUtils.formatNumberToStandardForm(paymentResponse[i].amount),
                        "amountPaid": GeneralUtils.formatNumberToStandardForm(paymentResponse[i].amount_paid),
                        "paymentMode": paymentResponse[i].payment_mode,
                        "outstandingAfter": GeneralUtils.formatNumberToStandardForm(paymentResponse[i].outstanding_after),
                        "creditBalanceAfter": GeneralUtils.formatNumberToStandardForm(paymentResponse[i].credit_balance_after),
                        "comment": paymentResponse[i].comment,
                    };
                    finalArrayForPayments.push(tempObject);
                }
            }
            if (searchKeyword) {
                var payLoadForPaymentHistory = {
                    totalRecords: finalArrayForSearchPayments.length,
                    data: finalArrayForSearchPayments,
                    withSearch: true
                }
            } else {
                var payLoadForPaymentHistory = {
                    totalRecords: receivedResponse.BillingSystem.response.dataset.totalrecordcnt,
                    data: finalArrayForPayments,
                    withSearch: false
                }
            }

        } catch (err) {
            payLoadForPaymentHistory = {
                totalRecords: 0,
                data: []
            };
        }
        this.setState({
            paymentHistoryPayload: payLoadForPaymentHistory
        })

    }

    initializeUserDetails() {
        var reduxCache = this.props.cache;
        try {
            var accountInfo = reduxCache.fetchAccountDetailsResponse;
            var accountInfoParams = accountInfo.BillingSystem.response.dataset.account_info[0];
            var accountBalanceDetails = accountInfoParams.balance_details;
            this.setState({
                billDueDate: GeneralUtils.formatDateToStandardForm(accountBalanceDetails.bill_due_date, this.props.configurationValues.dateFormatForBilling),
                //totalOutstandingAmount: GeneralUtils.formatNumberToStandardForm(accountBalanceDetails.outstanding_balance),
            });
        } catch (err) {

        }
    }

    initializeQuerySubscriber(receivedResponse) {
        var params = [];
        try {
            params = receivedResponse.profile_info.basic_details;
        } catch (err) {
            params = [];
        }

        var firstName = "";
        var lastName = "";
        var emailId = "";
        var finalContactNumber = "";
        for (var i = 0; i < params.length; i++) {
            if (params[i].id === "first_name") {
                firstName = params[i].value;
            }
            if (params[i].id === "last_name") {
                lastName = params[i].value;
            }
            if (params[i].id === "contact_number_1") {
                finalContactNumber = params[i].value;
            }
            if (params[i].id === "contact_email_id") {
                emailId = params[i].value;
            }
        }
        this.setState({
            contactNumber: finalContactNumber,
            firstName: firstName,
            lastName: lastName,
            emailId: emailId
        });
        try {
            var accountInfo = receivedResponse;
            var accountInfoParams = accountInfo.account_info.basic_details;
            var finalAccountStatus = "";
            var finalAccountEmailId = "";
            var dueAmount = 0;
            for (var k = 0; k < accountInfoParams.length; k++) {
                if (accountInfoParams[k].id === "status") {     // to know active user or not
                    finalAccountStatus = accountInfoParams[k].value;
                }
                if (accountInfoParams[k].id === "notification_email_id") {     // to know active user or not
                    finalAccountEmailId = accountInfoParams[k].value;
                }
                if (accountInfoParams[k].id === "outstanding_balance") dueAmount = accountInfoParams[k].value;
            }
           
           
            this.setState({
                totalOutstandingAmount: dueAmount,
                accountEmailId: finalAccountEmailId
            });
        } catch (err) {

        }

    }

    populatePaymentHistoryDetailsInSlider() {
        for (var i = 0; i < this.state.paymentHistoryPayload.data.length; i++) {
            var item = this.state.paymentHistoryPayload.data[i]
            if (this.state.paymentKey === item.paymentId) {
                return (
                    <tbody>
                        <tr><th>{this.props.locales.BillPaymentPaymentDateTable}</th><td>{item.paymentDate}</td></tr>
                        <tr><th>{this.props.locales.BillPaymentPaymentReferTable}</th><td>{item.paymentReferance}</td></tr>
                        <tr><th>{this.props.locales.BillPaymentAmtPaidTable} ({Constants.dollarSign})</th><td>{item.amountPaid}</td></tr>
                        <tr><th>{this.props.locales.BillPaymentPaymentModeTable}</th><td>{item.paymentMode}</td></tr>
                        <tr><th>{this.props.locales.BillPaymentOutstandingTable} ({Constants.dollarSign})</th><td style={{ color: '#bf112c' }}>{item.outstandingAfter}</td></tr>
                        {/* <tr><th>Credit Blance </th> <td style={{color:'#106306'}}>{item.creditBalanceAfter}</td></tr> */}
                        <tr><th>{this.props.locales.BillPaymentCommentTable}</th><td>{item.comment}</td></tr>

                    </tbody>
                )
            }
        }
        if (this.state.paymentHistoryPayload.data.length == 0) {
            return (<NoDataFound content="No Payment Details Found" />);
        }
    }

    paymentHistoryModalHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            this.setState({ isPaymentHistoryModalVisible: false })
        }

    }

    paymentHistoryTableHandler = (dataObject) => {
        if (dataObject.type === "firstTimeLoad" || dataObject.type === "pagination") {
            //console.log("dataObject Type >> ", dataObject.type)
            //this.setState({ isLoading: true });
            //Network.executeAxios("getPaymentDetails", "POST", { "offset": dataObject.offset, "limit": dataObject.limit }, (paymentResponse) => {
            Network.executeAxios("getPaymentDetails", "POST", {}, (paymentResponse) => {
                this.initializePaymentHistory(paymentResponse);
            });
        } else if (dataObject.type === "viewMore") {
            this.setState({
                isPaymentHistoryModalVisible: true,
                paymentKey: dataObject.paymentId
            })
        } else if (dataObject.type === "paymentDownload") {
            var paymentDetails={}
            for (var i = 0; i < this.state.paymentHistoryPayload.data.length; i++) {
                var item = this.state.paymentHistoryPayload.data[i]
                if (dataObject.paymentId === item.paymentId) {
                   paymentDetails = item;
                }
            }
            this.setState({
                paymentDetailsObj: paymentDetails
            },() => {
                this.savePdf();
            });
        } else if (dataObject.type === "search") {
            var searchWord = dataObject.searchKeyword;
            console.log("searchWord >> ", searchWord);
            if (searchWord && searchWord != "" && searchWord.length > 1) {
                console.log("get all details")
                Network.executeAxios("getPaymentDetails", "POST", {}, (paymentResponseSearch) => {
                    //this.initializePaymentHistory(paymentResponseSearch, dataObject.searchKeyword);
                    this.initializePaymentHistory(paymentResponseSearch);
                });
            } else {
                console.log("get first 5 details")
                Network.executeAxios("getPaymentDetails", "POST", {}, (paymentResponseSearch) => {
                    //Network.executeAxios("getPaymentDetails", "POST", { "offset": "1", "limit": "5" }, (paymentResponseSearch) => {
                    this.initializePaymentHistory(paymentResponseSearch);
                });
            }
        }
    }

    billHistoryTableHandler = (dataObject) => {
        if (dataObject.type === "firstTimeLoad" || dataObject.type === "pagination") {
            this.setState({ "dummy": "dummy" })
        } else if (dataObject.type === "download") {
            console.log("bill Id >> " + dataObject.billId);
            window.open("invoiceDownload/" + dataObject.billId);
        }  else if (dataObject.type === "itemised") {
            console.log("bill Id >> " + dataObject.billId);
            window.open("invoiceDownload/" + dataObject.billId);
        }  else if (dataObject.type === "summarised") {
            console.log("bill Id >> " + dataObject.billId);
            window.open("summarisedInvoiceDownload/" + dataObject.billId);
        } else if(dataObject.type === "pay"){
            this.state.isPaymentComponent = true
            this.setState({ dummy: "dummy" })
        }
    }

    currentInvoiceDownloadButtonClicked() {
        window.open("invoiceDownload/" + this.state.currentBillDetails.tempBillId);
    }

    savePdf() {
        this.setState({
            isPaymentReceiptVisible: true
        }, () => {
            const pdf = new jsPDF({
                orientation: "p",
                unit: "px",
                format: "a4",
                compress: true
            });
    
            const element = document.getElementById('divToPrint');
    
            const paymentId = this.state.paymentDetailsObj.paymentId;
    
            if (element) {
                // Define margins
                const margin = 18;
                const width = pdf.internal.pageSize.getWidth() - 2 * margin;
                const height = pdf.internal.pageSize.getHeight() - 2 * margin;
    
                // Render content onto PDF
                html2canvas(element).then(canvas => {
                    const imgData = canvas.toDataURL('image/png');
                    pdf.addImage(imgData, 'PNG', margin, margin, width, height);
                    pdf.save('Payment_' + paymentId + '.pdf');
                });
            }
    
            this.setState({
                isPaymentReceiptVisible: false
            });
        });
    }
    

    initializeBillHistory = (receivedResponse) => {
        var billResponse = [];
        try {
            billResponse = receivedResponse.BillingSystem.response.dataset.recordset
        } catch (err) {

        }
        if (billResponse.length > 0) {
            this.setState({
                isInvoicesAvailable: true
            })
        } else {
            this.setState({
                isInvoicesAvailable: false,
                totalInvoicesCount: 0
            })
        }
        var finalArrayForBills = [];
        var openInvoices = [];    // array of invoices those is_paid is 0 and exceeded due date 
        var totalRecords = ""
        try {
            this.setState({
                totalInvoicesCount: billResponse.length
            })
            if (billResponse.length > 0) {
                var count = 0;
                for (var i = 0; i < billResponse.length; i++) {

                    if (billResponse[i].is_paid === "0") {    // open invoice 
                        count++;
                        openInvoices.push(billResponse[i]);
                    }
                    var tempObject = {
                        "billPeriod": GeneralUtils.formatDateToStandardForm(billResponse[i].from_date, this.props.configurationValues.dateFormatForBilling) + " - " + GeneralUtils.formatDateToStandardForm(billResponse[i].to_date, this.props.configurationValues.dateFormatForBilling),
                        "billNumber": billResponse[i].bill_id,
                        "billDueDate": GeneralUtils.formatDateToStandardForm(billResponse[i].due_date, this.props.configurationValues.dateFormatForBilling),
                        "billDate": GeneralUtils.formatDateToStandardForm(billResponse[i].bill_date, this.props.configurationValues.dateFormatForBilling, "MM/DD/YYYY"),
                        "billId": billResponse[i].bill_id,
                        "tempBillId": billResponse[i].temp_bill_id,
                        "billAmount": GeneralUtils.formatNumberToStandardForm(billResponse[i].current_cycle_charges_with_tax,this.props.configurationValues),
                        "outstandingAmount": GeneralUtils.formatNumberToStandardForm(billResponse[i].total_bill_charge,this.props.configurationValues),
                        "generationDate": GeneralUtils.formatDateToStandardForm(billResponse[i].from_date, this.props.configurationValues.dateFormatForBilling),
                        "isPaid": billResponse[i].is_paid,
                        "toDate": GeneralUtils.formatDateToStandardForm(billResponse[i].to_date, this.props.configurationValues.dateFormatForBilling),
                        "pendingInvoiceAmount": GeneralUtils.formatNumberToStandardForm(billResponse[i].pending_invoice_amount,this.props.configurationValues),
                        "paymentStatus": billResponse[i].clear_status === "0" ? "Unpaid" : "Paid"
                    };
                    finalArrayForBills.push(tempObject);
                }
                this.state.isPaid = count;
               
                finalArrayForBills.sort((a, b) => new Date(b.billDate) - new Date(a.billDate));


                console.log("Number of Open Invoices =>> ", this.state.isPaid)
               
                var generationArray = []
                for (var i = 0; i < finalArrayForBills.length; i++) {
                    generationArray.push(finalArrayForBills[i].billNumber)
                }
                // let moments = generationDatesArray.map(d => moment(d)),
                //     maxDate = moment.max(moments).format("MM/DD/YYYY")


                var maxBillId = Math.max.apply(null, generationArray);

                var currentBillDetails = []
                for (var j = 0; j < finalArrayForBills.length; j++) {
                    if (maxBillId == finalArrayForBills[j].billNumber) {
                        currentBillDetails.push(finalArrayForBills[j])
                    }
                }

                this.state.currentBillDetails = currentBillDetails[0]
                // if (this.state.isPaid >= 2) {
                //     this.getLastOpenInvoiceArray(this.state.openInvoicesArray, maxDate)
                // }

                // var addonIndexToBeRemoved = ""
                 var flag = 0;
                // for (var j = 0; j < finalArrayForBills.length; j++) {
                //     if (finalArrayForBills[j].billId === this.state.currentBillDetails.billId) {
                //         addonIndexToBeRemoved = j;
                //         flag = 1;
                //     }
                // }
                // finalArrayForBills.splice(addonIndexToBeRemoved, 1);
                var recordCount = ""
                if (flag === 1) {
                    recordCount = receivedResponse.total_record_count - 1
                } else {
                    recordCount = receivedResponse.total_record_count
                }

                console.log("BILL INVOICES => ",finalArrayForBills)

                var payLoadForBillHistory = {
                    totalRecords: recordCount,
                    data: finalArrayForBills
                }

                this.setState({ "dummy": "dummy" })

            }

        } catch (err) {
            payLoadForBillHistory = {
                totalRecords: 0,
                data: []
            };
        }
        this.setState({
            billsHistoryPayload: payLoadForBillHistory
        })

    }

    handleScroll = (event) => {
        if (window.scrollY > 190) {
            this.setState({ isFloatingSubMenuVisible: true });
        } else {
            this.setState({ isFloatingSubMenuVisible: false });
        }
    }

    myCallback = (isPaymentComponentEnabled) => {
        this.setState({
            isPaymentComponent: isPaymentComponentEnabled
        })
    }

   

    subMenuClicked = (type,receivedServiceId,serviceAddress,isAddFnFAddon) => {
        this.setState({ currentActiveSubMenu: type,serviceId:receivedServiceId, serviceAddress:serviceAddress, isAddFnFAddon: isAddFnFAddon});
        // if (window.scrollY > 0) {
        //     window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        //     setTimeout(() => {
        //         this.setState({ currentActiveSubMenu: type });
        //     }, 500);
        // } else {
        //     this.setState({ currentActiveSubMenu: type });
        // }
    }

    render() {
        return (
            <div className="col-md-12 animated fadeIn justify-content-center">
                <div id="ChangePlanComponentContainer">
                    {this.state.isLoading  === true ? <LoadingAnimation isVisible={true} /> : this.componentContent()}
                </div>

            </div>
        );
    }

    componentContent(){
        return(
        <div id="billingAndPaymentMainContainer">
            <div className='col-md-12 row m-0 pb-3 justify-content-center' style={{flex:1}}>
            <div></div>
            {this.state.isPaymentReceiptVisible ?
                        <div id="divToPrint">
                            {/* <PaymentReceiptComponent 
                                paymentDetails={this.state.paymentDetailsObj}
                                accountId={this.state.accountId}
                                isVisible={this.state.isPaymentReceiptVisible}
                            /> */}
                             <div className='paymentReceiptDiv col-md-12 p-5'>
                            <div className='justify-content-between col-md-12 row'>
                                <img src={ApuaWhiteTextLogo} alt="" />
                                <div className='col-md-7 row'>
                                    <div className="col-12 m-0 p-0 d-flex align-items-center pb-2 text-right justify-content-end">
                                        <div className="summaryBoxLabel">Account ID</div>
                                        <div className="summaryBoxData">: &nbsp;{this.props.cache.serviceInfo.accountId}</div>
                                    </div>
                                    <div className="col-12 m-0 p-0 d-flex align-items-center pb-2 text-right justify-content-end">
                                        <div className="summaryBoxLabel">{this.props.locales.BillingAndPaymentreceiptNumArryHeader}</div>
                                        <div className="summaryBoxData">: &nbsp;{this.state.paymentDetailsObj.paymentReferance}</div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className='col-md-12 row py-3'>
                                <div className='col-md-12 pb-3'>
                                    {this.populateContactSummary()}
                                </div>
                                <div className='col-md-12'>
                                    {this.populateAccountSummary()}
                                </div>
                            </div>
                        </div>
                            </div>
                        : null }
            <div className='d-flex'>
                <div className={this.state.tab === "billingHistory" ? "redButtonContainer p-3 m-2" : "blueButtonContainer p-3 m-2"} onClick={(event) => { this.generalBtnClicked("billingHistory") }}>Invoices</div>
            </div>
            <div className='d-flex'>
                <div className={this.state.tab === "paymentHistory" ? "redButtonContainer p-3 m-2" : "blueButtonContainer p-3 m-2"} onClick={(event) => { this.generalBtnClicked("paymentHistory") }}>Payment</div>
            </div>
        </div>
        {this.state.tab === "billingHistory" ? this.renderBillHistory() : this.renderPaymentHistory() }

        <SliderModal
                    isVisible={this.state.isPaymentHistoryModalVisible}
                    uniqueModalReferenceId="paymentHistory"
                    mainHeading={this.props.locales.paymentHistorySliderMainHeading}
                    leftPartFlexValue={2}
                    rightPartFlexValue={1}
                    isResetButtonVisible={false}
                    isSubmitButtonVisible={false}
                    callback={this.paymentHistoryModalHandler}
                >
                    <div className="col-md-12" id="">
                        <table className="table">
                            {this.populatePaymentHistoryDetailsInSlider()}
                        </table>

                    </div>
                </SliderModal>
                
            {this.state.isPaymentComponent ?
                    <PaymentComponent amount={this.state.totalOutstandingAmount}
                        accountId={this.state.accountId}
                        billId={this.state.secondLastInvoiceDetails.bill_id}
                        billDueDate={this.state.billDueDate}
                        billStartDate={this.state.billStartDate}
                        billEndDate={this.state.billEndDate}
                        billPeriod={this.state.currentBillDetails.billPeriod}
                        firstName={this.state.firstName}
                        lastName={this.state.lastName}
                        phoneNumber={this.state.contactNumber}
                        emailId={this.state.accountEmailId}
                        profileId={this.state.profileId}
                        callbackFromParent={this.myCallback}
                    />
                    :
                    null
                }

        </div>
        )
    }

    renderPaymentHistory(){
        return(
            <div ref="billingAndPaymentsPaymentHistoryPart" id="billingAndPaymentsPaymentHistoryPart" className="col-md-12 mb-5" style={{ backgroundColor: '#FFFFFF', borderRadius: 6, marginTop: 20, boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)', overflow: "auto" }}>

                                    <TableComponent
                                        headerArray={[
                                            {
                                                key: "paymentDate",
                                                label: this.props.locales.BillingAndPaymentPaymentDateArryHeader
                                                // Payment Date
                                            }, {
                                                key: "paymentReferance",
                                                label: this.props.locales.BillingAndPaymentreceiptNumArryHeader
                                                // Bill Number
                                            },

                                            {
                                                key: "amountPaid",
                                                label: this.props.locales.BillingAndPaymentAmtPaidArrayHeader + "(" + Constants.dollarSign + ")"
                                                // Amount Paid
                                            },
                                            {
                                                key: "paymentMode",
                                                label: this.props.locales.BillingAndPaymentPayModeArrayHeader
                                                // Payment Mode
                                            },
                                            {
                                                key: "action",
                                                label: "Action",
                                                formatter: (rowData, callback) => {
                                                    return (
                                                        <div>
                                                            <img src={viewIcon} alt="" style={{ cursor: 'pointer' }} onClick={() => callback({ "type": "viewMore", "paymentId": rowData.paymentId })} />
                                                            <MdVerticalAlignBottom style={{ cursor: 'pointer' }} size="22" className="ml-3" color='#33495F' onClick={() => callback({ "type": "paymentDownload", "transactionId": rowData.paymentReferance, "paymentId": rowData.paymentId })} />
                                                        </div>
                                                    );
                                                }
                                            }
                                        ]}
                                        payload={this.state.paymentHistoryPayload}
                                        isSearchRequired={true}
                                        //paginationType="server"
                                        limit={5}
                                        tableUniqueId="paymentHistoryTable"
                                        callback={this.paymentHistoryTableHandler}
                                    />
                                </div>
        )
    }

    

    renderBillHistory(){
        return(
            <div ref="billingAndPaymentsPaymentBillsPart" id="billingAndPaymentsPaymentBillsPart" className="col-md-12 mb-5" style={{ backgroundColor: '#FFFFFF', borderRadius: 6, marginTop: 20, boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)', overflow: "auto" }}>

            <TableComponent
                headerArray={[
                    {
                        key: "billId",
                        label: "Invoice ID"
                        // Bill Period
                    },
                    {
                        key: "billDate",
                        label: "Invoice Date"
                        // Bill Period
                    },
                    {
                        key: "billPeriod",
                        label: this.props.locales.BillingAndPaymentBillPeriodArryHeader
                        // Bill Period
                    },

                    {
                        key: "billDueDate",
                        label: this.props.locales.BillingAndPaymentBillDueDaterArryHeader
                        // Bill Due Date
                    },
                    {
                        key: "billAmount",
                        label: this.props.locales.BillingAndPaymentBillAmtArryHeader + "(" + Constants.dollarSign + ")"
                        // Bill Amount
                    },
                    {
                        key: "outstandingAmount",
                        label: this.props.locales.BillingAndPaymentOutstandingAmtArryHeader + "(" + Constants.dollarSign + ")"
                        // Outstanding Amount
                    },

                    {
                        key: "action",
                        label: "Summarised Invoice",
                        formatter: (rowData, callback) => {
                            return (
                                <div className="">
                                    <img src={downloadIcon} alt="" style={{ cursor: 'pointer' }} onClick={() => callback({ "type": "summarised", "billId": rowData.tempBillId })} />
                                </div>
                            )
                        }
                    },
                    {
                        key: "action",
                        label: "Itemised Invoice",
                        formatter: (rowData, callback) => {
                            return (
                                <div className="">
                                    <img src={downloadIcon} alt="" style={{ cursor: 'pointer' }} onClick={() => callback({ "type": "itemised", "billId": rowData.tempBillId })} />
                                </div>
                            )
                        }
                    }

                ]}
                payload={this.state.billsHistoryPayload}
                isSearchRequired={false}
                noDataContentText={this.props.locales.noDataContentTextForInvoiceHistory}
                limit={5}
                paginationType="server"
                isPayButtonRequired={true}
                tableUniqueId="billHistoryTable"
                callback={this.billHistoryTableHandler}
            />
        </div>
        )
    }

}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        configurationValues: state.configurationValues
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        }
    }
}

const InvoicesComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(InvoicesComponent)

export default InvoicesComponentContainer;
